"use client";
import React, { useEffect, useState } from "react";
import { SimpleGrid, Stack, Icon, Box, Heading, Text, VStack } from "@chakra-ui/react";
import { IconType } from "@onemind-services-llc/react-icons-ng";
import { SectionDivider } from "../SectionDivider";
import { PROGRAM_DETAILS_LIST } from "app/partner-program/constant";
import { VISION_MISSION_LIST } from "app/about-us/constant";

type Props = { content: string; icon?: IconType; title: string; index: number };

export const ProgramCard = (props: Props) => {
  const { content, icon, title, index } = props;

  return (
    <Box
      p={4}
      boxShadow={"md"}
      border={"1px solid #aaa"}
      borderRadius={"8px"}
      transition={"0.15s"}
      _hover={{
        transform: "scale(1.03)",
        boxShadow: "lg",
      }}
      data-cy={`program-card-${index}`}
    >
      <VStack spacing={5}>
        <Icon
          as={icon}
          fontSize={"120px"}
          color={"brand.100"}
          transition="transform .2s"
        />
        <Heading as={"h3"} textAlign={"center"} fontWeight={600} fontSize={"2xl"}>
          {title}
        </Heading>
        <Text textAlign={"center"} fontSize={"20px"} color={"gray.700"}>
          {content}
        </Text>
      </VStack>
    </Box>
  );
};

const ProgramDetails = (props: { type: string; title: string }) => {
  const { type, title } = props;
  const [arr, setArr] = useState(PROGRAM_DETAILS_LIST);

  useEffect(() => {
    if (type === "partner-program") setArr(PROGRAM_DETAILS_LIST);
    else if (type === "about-us") setArr(VISION_MISSION_LIST);
  }, [type]);

  return (
    <Stack data-cy={"section-partner-details"} px={8}>
      <SectionDivider label={title} padding="0 2rem" />
      <SimpleGrid w="full" columns={{ base: 1, md: 3 }} spacing={6}>
        {arr.length > 0 &&
          arr?.map((program, index) => (
            <ProgramCard key={index} {...program} index={index} />
          ))}
      </SimpleGrid>
    </Stack>
  );
};

export default ProgramDetails;
